(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-mega-menu"] && !Shopify.designMode) return;
  try {
    class HeaderMenu extends HTMLElement {
    connectedCallback() {
      this._details = this.querySelector('details');
      if (!this._details) return;
      this.addEventListener('mouseenter', this._open.bind(this));
      this.addEventListener('mouseleave', this._close.bind(this));
    }
    _open() {
      if (window.innerWidth < 990) return;
      this._details.open = true;
    }
    _close() {
      this._details.open = false;
    }
    close() { this._close(); }
  }
  if (!customElements.get('header-menu')) {
    customElements.define('header-menu', HeaderMenu);
  }
  } catch(e) { console.error(e); }
})();

})();
